<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="app">
      <v-snackbar
        v-model="showSnackBar"
        color="#FF1313"
        right
        :timeout="timeout"
      >
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showSnackBar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>

      <!-- <v-dialog
        v-model="queryPopUpDialog"
        persistent
        :width="
          $vuetify.breakpoint.name == 'xs'
            ? '100vw'
            : $vuetify.breakpoint.name == 'sm'
            ? '50vw'
            : $vuetify.breakpoint.name == 'md'
            ? '40vw'
            : $vuetify.breakpoint.name == 'lg'
            ? '30vw'
            : '25vw'
        "
      >
        <v-card tile color="#FFFFFF">
          <v-layout wrap justify-center pa-2>
            <v-flex xs12>
              <QueryPopUp @stepper="winStepper2" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog> -->

      <!-- <AppMainHeader v-if="$route.path != '/'" v-bind:storage="styloopData" :key="styloopData.facebook" />
      <v-divider></v-divider>
      <AppHeader v-if="$route.path == '/appHome'" @stepper="winStepper" />
      <AppHeader2 v-if="$route.name != 'Login' && $route.path != '/'" />
      <v-divider v-if="$route.name != 'Login'"></v-divider> -->

      <!-- Main eidi -->
      <AppMainHeader v-if="appUserType == 'Client'" />
      <v-divider></v-divider>
      <AppHeader v-if="appUserType == 'Client'" @stepper="winStepper" />
      <AppHeader2
        :style="$vuetify.breakpoint.name == 'md' ? 'padding-bottom:50px' : ''"
        v-if="
          $route.name != 'Login' &&
          appUserType != 'Client' &&
          $route.path != '/'
        "
      />
      <!-- <v-divider v-if="appUserType !== 'Client'"></v-divider> -->
      <Search
        :style="
          $vuetify.breakpoint.name == 'xs'
            ? 'padding-top:50px'
            : $vuetify.breakpoint.name == 'sm'
            ? 'padding-top:50px'
            : ''
        "
        v-if="
          $route.name != 'Profile' &&
          $route.name != 'Edit Profile' &&
          appUserType == 'Client'
        "
      />
      <router-view
        style="min-height: 80vh"
        :key="$route.fullPath"
        v-bind:storage="sideNav"
      />
      <AppFooter
        v-if="$route.name != 'Login' && $route.name != 'newHome'"
        v-bind:storage="styloopData"
      />
    </v-app>
    <!-- <AppFooter v-if="$route.name != 'Login'" v-bind:storage="styloopData" /> -->
  </div>
</template>
<script>
import AppMainHeader from "./components/Common/appHeader0";
import AppHeader from "./components/Common/appHeader";
import AppHeader2 from "./components/Common/appHeader2";
import AppFooter from "./components/Common/appFooter";
import Search from "./components/Common/searchbar";

// import QueryPopUp from "./components/Common/queryPopUp";
import axios from "axios";

import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";

export default {
  components: {
    AppMainHeader,
    AppHeader,
    AppHeader2,
    AppFooter,
    Search,
    // QueryPopUp,
  },
  data() {
    return {
      sideNav: false,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      msg: null,
      timeout: 5000,
      styloopData: {},
      queryPopUpDialog: false,
    };
  },
  computed: {
    appUserType() {
      return this.$store.state.userType;
    },
  },
  beforeMount() {
    this.getSettings();
    if (typeof localStorage.getItem("token") == "string") {
      this.getProfile();
    } else {
      this.$store.commit("userType", "Client");
      if (this.getCookie("LookingFor") == "false") {
        return;
      } else {
        setTimeout(() => {
          this.queryPopUpDialog = true;
        }, 10000);
      }
    }
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    getProfile() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("loginUser", response.data.status);
            this.$store.commit("changeCart", response.data.cartcount);
            this.$store.commit("changeWishlist", response.data.wishlistcount);
            this.$store.commit("userData", response.data.data);
            this.$store.commit("coupen", response.data.coupen);
            this.$store.commit("userType", response.data.data.type);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    winStepper(windowData) {
      this.sideNav = windowData.sideNav;
    },
    winStepper2(windowData) {
      this.queryPopUpDialog = windowData.dialog;
      if (windowData.msg) {
        this.msg = windowData.msg;
        this.showSnackBar = true;
      }
    },
    getSettings() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/settings/getlist",
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            var settings = response.data.data;
            for (var i = 0; i < settings.length; i++) {
              if (settings[i].Name == "FacebookLink") {
                this.styloopData.facebook = settings[i].Value;
              }
              if (settings[i].Name == "InstagramLink") {
                this.styloopData.instagram = settings[i].Value;
              }
              if (settings[i].Name == "Gmail") {
                this.styloopData.gmail = settings[i].Value;
              }
              if (settings[i].Name == "Whatsapp") {
                this.styloopData.whatsapp = settings[i].Value;
              }
              if (settings[i].Name == "StyloopDescription") {
                this.styloopData.description = settings[i].Value;
              }
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>